<template>
    <div id="data-entry-notes-right-sheet">
        <div class="data-entry-notes-right-sheet-header">
            <SearchResultAvatar v-if="currentEntity" :entity="currentEntity" size="medium" />
            <h2 v-if="currentEntity">{{ title }} - Notes</h2>
            <span class="material-icons" @click="closeDrawer">close</span>
        </div>
        <NotesPanel :entityType="entityType" :entityId="entityId" v-if="currentEntity" />
    </div>
</template>
<script>
import SearchResultAvatar from '@/components/Search/avatar'
import NotesPanel from './Panel'
import actions from '@/store/actions'
import entityTypes from '@/utils/entityTypes'

export default {
    components: {
        SearchResultAvatar,
        NotesPanel,
    },
    data() {
        return {
            currentEntity: null,
        }
    },
    watch: {
        storeEntity() {
            this.currentEntity = this.storeEntity ?? this.currentEntity
        },
    },
    mounted() {
        this.currentEntity = this.storeEntity
    },
    computed: {
        storeEntity() {
            return this.$store.getters.currentEntity
        },
        entityId() {
            return this.currentEntity?.id
        },
        entityType() {
            return this.currentEntity?.type
        },
        title() {
            switch (this.entityType) {
                case entityTypes.executive:
                    return this.currentEntity.colloquialName
                case entityTypes.company:
                    return this.currentEntity.name
                default:
                    return ''
            }
        },
    },
    methods: {
        closeDrawer() {
            this.$store.dispatch(actions.clearRightDrawer)
        },
    },
}
</script>
<style>
#data-entry-notes-right-sheet {
    height: 100%;
    overflow: hidden;

    .data-entry-notes-right-sheet-header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        margin: 0;
        background-color: #cc0000;
        padding: 20px 24px;

        img {
            flex-shrink: 1;
        }

        h2 {
            color: var(--color-primary-100);
            flex-grow: 1;
            line-height: 48px;
        }

        .material-icons {
            color: var(--color-primary-100);
            cursor: pointer;
            flex-shrink: 1;
            text-align: right;
        }
    }

    .data-entry-notes-panel {
        height: calc(100% - 88px);
        overflow: auto;
    }
}
</style>
